import React from 'react';
import './CategorySelector.css';

const CategorySelector = ({ categories, selectedCategory, onCategoryChange }) => {
  // Filtrar solo las categorías que existen
  const availableCategories = categories.filter(cat => 
    cat.id === 'coffee' || cat.id === 'smoothies' || 
    cat.id === 'bakery' || cat.id === 'salads'
  );

  return (
    <div className="category-selector">
      <div className="category-tabs">
        {availableCategories.map(category => (
          <button
            key={category.id}
            className={`category-tab ${selectedCategory === category.id ? 'active' : ''}`}
            onClick={() => onCategoryChange(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategorySelector;